import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { initGA, pageview } from './lib/analytics';
import Layout from './components/Layout';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Admin from './pages/Admin';
import './index.css';

// Initialize Google Analytics
initGA();

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    loader: ({ request }) => {
      // Track page views
      pageview(new URL(request.url).pathname);
      return null;
    },
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'how-it-works',
        element: <HowItWorks />,
      },
      {
        path: 'admin',
        element: <Admin />,
      }
    ],
  }
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>,
);
